import dayjs from 'dayjs'
import { API_DATETIME_FORMAT } from './constants'

export const getUtcOffset: () => string = () => dayjs().format('Z')

export const getNowTimeString: () => string = () =>
  dayjs().format(API_DATETIME_FORMAT)
